<template>
    <v-card color="#f2f2f2">
        <v-card-title>Solicitar alteração do preço unitário de tabela</v-card-title>
        <v-card-text>Esta alteração será aplicada não só nesta cotação, mas também na sua tabela de preços em nosso
            sistema.<br>
            <strong>Considere sempre valor bruto, ou seja, com 20% de comissão de agência.</strong>
            <div class="pt-3">
                <v-text-field v-model.lazy="changePriceTable.priceTable" v-money="money" label="Valor bruto" outlined>

                </v-text-field>
                <v-textarea v-model="changePriceTable.observation" label="Observações" outlined></v-textarea>
            </div>
            <div class="pt-3 d-flex">
                <v-spacer></v-spacer>
                <v-btn text @click="cancel()" class="mx-1">Cancelar</v-btn>
                <v-btn color="primary" class="mr-1" elevation="0" @click="send()" :loading="processing">Confirmar solicitação</v-btn>
            </div>
        </v-card-text>
    </v-card>
</template>
<script>
import jsFunctions from "@/plugins/helper";
import { showSuccess, showError } from '@/plugins/snackbar-helper';

export default {
    name: "AsuRequest",
    data() {
        return {
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false /* doesn't work with directive */
            },
            changePriceTable: {
                applyForInventary: true,
                priceTable: 0.0,
                prePriceTable: 0.0,
                observation: ''
            },
            processing: false
        };
    },
    props: {
        request: {
            type: Object,
        }
    },
    computed: {
        tablePrice(){
            const price = this.changePriceTable.priceTable
            if(price.includes('R$ '))
                return parseFloat(price.split('R$ ').join('').split('.').join('').split(',').join('.'))
            else
                return parseFloat(price.split('.').join('').split(',').join('.')) 
        },
        tablePriceAudit() {
            return {
                oldPriceTable: this.request.newPriceTable != null
                    ? this.request.newPriceTable
                    : this.request.asuFormat.asus.private_pricing_info.unity_price,
                priceTable: this.tablePrice,
                inventaryName: this.request.asuFormat.display_name,
                updateInventary: this.changePriceTable.applyForInventary,
                gridId: parseInt(this.$route.params.gridId),
                gridVersion: parseInt(this.request.gridVersion),
                type: 'order',
                observation: this.changePriceTable.observation,
                orderId: this.request.ord_ids.split(',')[0],
                orderReferId: this.request?.referId? this.request.referId : null,
                asuId: this.request.asuId,
                syncId: this.request.orderSyncId,
                sku: this.request.ord_sku,
                uri: this.request.uri
            }
        }
    },
    methods: {
        cancel(){
            this.$emit('close-dialog', false)
        },
        send() {
            this.processing = true
            this.$axios.post(`quotation/publisher/price-table/solicitation`, this.tablePriceAudit)
                .then((data) => {
                    this.processing = false
                    showSuccess('Solicitação de alteração de preço enviada com sucesso!')
                    this.$emit('close-dialog', false)
                    this.$emit('price-updated')
                })
                .catch((error) => {
                    this.processing = false
                    showError('Erro ao enviar solicitação. Tente novamente.')
                })
        }
    },
    mounted() {
        const { unity_price, markup } = this.request.asuFormat.asus.private_pricing_info
        const baseBruto = this.request.newPriceTable != null ? this.request.newPriceTable : markup * unity_price
        this.changePriceTable.priceTable = baseBruto * 100
    }
};
</script>
<style lang="scss">
.--info {
    .card {
        position: relative;
    }

    .v-list {
        padding: 0;
    }

    .v-list-item {
        padding: 0;
    }

    .v-list-item__content {
        padding: 0;
    }

    h3 {
        color: #707070;
    }

    .--label {
        position: absolute;
        bottom: 10px;
        left: 10px;
        padding: 3px;
        background: #fff;
        color: #909090;
        font-weight: bold;
        font-size: 12px;
    }

    .v-toolbar--extended {
        height: auto !important;
    }

    .v-toolbar__content {
        min-height: 64px;
        height: auto !important;
    }

    .theme--light.v-tabs-items {
        background: #f2f2f2;
    }

    @media screen and (max-width: 480px) {

        .v-slide-group__next,
        .v-slide-group__prev {
            flex: 0 1 20px;
            min-width: 20px;
        }

        .v-toolbar__extension {
            height: auto !important;
        }

        .v-tabs--vertical {
            height: auto !important;

            .v-slide-group__wrapper {
                height: auto;
            }

            .v-tab {
                margin-left: 0 !important;
                margin-right: 0 !important;
            }
        }

        .--info-header {
            flex-flow: column;
        }

        .--info-title {
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
        }

        .--info-title-line {
            flex-flow: column;
            flex-wrap: wrap;
            justify-content: center;

            strong {
                display: flex;
                justify-content: center;
            }
        }

        .--info-title-subline {
            font-size: 15px;
            flex-flow: column;
        }

        .--close {
            position: absolute;
            top: 5px;
            right: 5px;
        }
    }
}
</style>